import HomeAssociateDetail from './AssociateReportModalProductPage';

export default HomeAssociateDetail;
